import { getEnvVariable } from '@/utils';

export const WEBSOCKET_ORIGIN = getEnvVariable('REACT_APP_WEBSOCKET_ORIGIN')